export const translations = {
  hu: {
    // ─── Navbar ───
    nav: {
      activities: 'Programok',
      gallery: 'Galéria',
      reviews: 'Vélemények',
      location: 'Helyszín',
      houseRules: 'Házirend',
      contact: 'Kapcsolat',
      booking: 'Foglalás',
    },

    // ─── Hero ───
    hero: {
      tagline: 'Esztergom · Pilis-hegység lábánál',
      subtitle: 'Vendégfavorit alpesi faház a természet ölelésében.',
      cta: 'Fedezd fel',
    },

    // ─── About ───
    about: {
      label: 'A Hely',
      heading1: 'nyugalom',
      heading2: 'adott.',
      p1: 'A haaziko alpesi faház a Pilis lábánál, az erdő szélén, Budapestről egy órán belül megközelíthető. A fa teraszon kültéri jacuzzi, ami egész évben üzemel. A természet kedvelőinek ajánljuk, akik kikapcsolódásra vágynak egy madárcsicsergős, zöld környezetben.',
      p2: 'A közel 4000 négyzetméteres ősfás telken a 80 négyzetméteres teraszon nem csak a reggeli kávé és mókusles lesz élmény, hanem a délutáni napozás is. A dombtetőről megcsodálhatod a panorámát a szomszéd hegyekre, este pedig jöhet a sütögetés, tábortűz a kertben.',
      cta: 'Nézz körül',
    },

    // ─── Gallery ───
    gallery: {
      label: 'A Szállás',
      heading: 'Nézz körül',
      headingItalic: 'nálunk.',
      cats: {
        interior: {
          label: 'Belső & Háló',
          desc: 'Nyitott, modern tér padlótól plafonig érő üvegfallal. A nappali és hálószoba egységes, harmonikus teret alkot — minden részlet ízléses és kényelmes.',
        },
        kitchen: {
          label: 'Konyha & Fürdő',
          desc: 'Teljesen felszerelt konyha és elegáns fürdőszoba — minden, ami kényelmes pihenéshez kell.',
        },
        garden: {
          label: 'Kert & Terasz',
          desc: '80 m² panorámás terasz a Pilis hegyeire néző kilátással. Közel 4000 m² ősfás telken grillezési és tábortűzrakási lehetőséggel.',
        },
        mood: {
          label: 'Hangulat',
          desc: 'Télen havas meseville, nyáron zöld oázis. A ház minden évszakban más-más arcát mutatja — de a nyugalom és a természet közelsége állandó.',
        },
      },
    },

    // ─── Stats ───
    stats: [
      { value: '1', unit: 'h', label: 'Budapesttől' },
      { value: '4000', unit: 'm²', label: 'ősfás telek' },
      { value: '80', unit: 'm²', label: 'panorámás terasz' },
      { value: '4,97', unit: '★', label: 'Airbnb értékelés' },
    ],

    // ─── Activities ───
    activities: {
      label: 'Programok',
      heading: 'Élmények,',
      headingItalic: 'amik várnak.',
      items: [
        {
          title: 'Kültéri jacuzzi',
          desc: 'A ház melletti fa teraszon, az ősfák alatt. Egész évben üzemel, és a foglalás része — hűvös estéken, ősszel és télen ez a vendégek kedvence.',
        },
        {
          title: 'Kerti sütögetés & tábortűz',
          desc: 'A közel 4000 m² ősfás kertben saját grillező és tábortűzrakó hely áll rendelkezésre. Esti bográcsozás, marshmallow pörkölés, csillagos ég — az igazi vidéki élmény.',
        },
        {
          title: 'Napozó terasz',
          desc: '80 m² sarokterasz panorámás kilátással a Pilis hegyeire. Reggeli kávé, mókusles, délutáni napozás — vagy csak ülj ki és hallgasd a csöndet.',
        },
        {
          title: 'Túrázás a Pilisben',
          desc: 'A ház közvetlen közelében indulnak a Pilis jelzett túraútjai. Holop-forrás, Dobogókő, Esztergom-Kőhegy — kezdőknek és tapasztalt túrázóknak egyaránt ideális terep.',
        },
      ],
    },

    // ─── Amenities ───
    amenities: {
      label: 'Felszereltség',
      heading: 'Minden benne van.',
      items: [
        { name: 'Jacuzzi', desc: 'Kültéri jacuzzi a ház melletti fa teraszon, egész évben, külön díj nélkül — hűvös estéken és télen is a kedvenc program.' },
        { name: 'Panorámás Birtok', desc: 'Közel 4000 m² ősfás telek dombtetőn, kilátással a szomszéd hegyekre.' },
        { name: 'Tábortűz & Grillezés', desc: 'Esti sütögetés, bográcsozás és tábortűzrakás a kertben.' },
        { name: 'Reggeli a Teraszon', desc: '80 m² terasz — reggeli kávé, mókusles és délutáni napozás.' },
        { name: 'Klíma & Padlófűtés', desc: 'Nyáron hűvös a splitklímával, télen meleg a padlófűtéssel.' },
        { name: 'HD-TV & Netflix', desc: '32 hüvelykes HD-tévé és Netflix az esti filmezésekhez.' },
        { name: 'Stabil WiFi', desc: 'Gyors internetkapcsolat — akár innen is dolgozhatsz, a videóhívások is mennek.' },
        { name: 'Ingyenes Parkoló', desc: 'Zárt udvarban, közvetlenül a ház mellett.' },
        { name: 'Önálló Bejutás', desc: 'Kódzáras dobozzal, rugalmas érkezés bármikor.' },
      ],
    },

    // ─── Testimonials ───
    testimonials: {
      label: 'Vendégeink mondták',
      airbnbSuffix: 'vélemény · Airbnb',
      googleSuffix: 'vélemény · Google',
      seeAll: 'Összes vélemény',
      reviews: [
        { name: 'Ferenc', text: 'Amikor a csodás környezet és stílus nem megy a használhatóság és kényelem rovására. Minden tényleg olyan, amilyennek szeretnéd — sosem érzed, hogy szép, de otthonra nem kéne. Mert de. Kéne.' },
        { name: 'Dóra', text: 'Csodálatos kisház a természet lágy ölén — imádtuk. Pont olyan, mint a képeken, kifogástalanul szép, kényelmes, jól felszerelt. A környék csodálatos, számtalan kirándulási lehetőség van.' },
        { name: 'Marcell', text: 'Nagyon nyugodt, természetközeli, békés hely, tökéletes elvonulni, pihenni. A szállás nagyon jól néz ki, tökéletes ízléssel lett megálmodva, az esti tűzrakási lehetőség pedig már csak hab a tortán.' },
        { name: 'Alina', text: 'Az első pillanattól kezdve melegnek, tisztának és hihetetlenül otthonosnak éreztem — igazi otthon távol az otthontól. Mintha egy havas téli mesében lettem volna. Nehéz volt elmenni.' },
        { name: 'Mátyás', text: 'Egy igazán gyönyörű, kiváló állapotú és jól felszerelt ház. A hely varázslatos hangulatot áraszt. Tökéletes választás pároknak, a környék mindig csendes és békés.' },
        { name: 'Cintia', text: 'Másodjára ünnepeltük a párom születésnapját ezen a csodás helyen. Biztosan jövünk még — ha rajta múlik, mindegyik születésnapját itt fogjuk ünnepelni.' },
      ],
    },

    // ─── Location ───
    location: {
      label: 'Helyszín',
      heading: 'Az erdő szélén,',
      headingItalic: 'mégis közel mindenhez.',
      addressTitle: '2500 Esztergom, Kusztusi utca 17.',
      addressDesc: 'Az erdő szélén, nyugodt környezetben, közel 4000 m² ősfás telken',
      distanceTitle: '1 óra Budapesttől',
      distanceDesc: 'Autóval kényelmesen megközelíthető, közvetlen a ház mellett zárt parkoló',
      nearbyHeading: 'Mit tehetsz a környéken',
      nearbyItems: [
        { name: 'Túrázás a Pilisben', desc: 'Számos jelzett túraútvonal indul a ház közeléből (Duna–Ipoly Nemzeti Park)', href: 'https://www.dunaipoly.hu/' },
        { name: 'Esztergom Belváros', desc: 'Bazilika, múzeumok, éttermek — autóval pár perc', href: 'https://www.bazilika-esztergom.hu/' },
        { name: 'Horgásztó', desc: 'Több horgásztó is megtalálható a közelben' },
        { name: 'Holop-forrás', desc: 'Rövid sétával megközelíthető természeti látnivaló' },
      ],
      paragraph: 'A haaziko nagy előnye, hogy amellett, hogy egyedi, nyugodt és természetközeli környezetben helyezkedik el, Esztergom közelsége lehetővé teszi a városi, kulturális programokat: autóval néhány perc alatt a belvárosban találod magad — múzeumok, éttermek, kávézók várnak a főtéren vagy a Bazilikánál.',
    },

    // ─── House Rules ───
    houseRules: {
      label: 'Házirend',
      heading: 'Néhány',
      headingItalic: 'tudnivaló.',
      checkinTitle: 'Bejelentkezés',
      checkinValue: '15:00 után',
      checkoutTitle: 'Kijelentkezés',
      checkoutValue: '11:00 előtt',
      maxGuestsLabel: 'max. vendég',
      maxGuestsPara: 'A haazikóban a maximális vendégszám 4 fő. Kérjük, hogy a házirendet minden vendégünkkel ismertesd.',
      rules: [
        { title: 'Nem dohányzó', desc: 'A ház teljes területén tilos a dohányzás.' },
        { title: 'Kisállat nem hozható', desc: 'Sajnos kedvenceinket otthon kell hagynunk.' },
        { title: 'Maximális vendégszám', desc: '4 fő — kérjük tartsd be a megadott létszámot.' },
        { title: 'Csend', desc: '22:00 és 08:00 között kérjük a csöndet a szomszédok érdekében.' },
        { title: 'Rendetlenség', desc: 'A házat az érkezéskor átvett rendezett állapotban kérjük visszaadni.' },
        { title: 'Tűzgyújtás', desc: 'Csak a kijelölt tábortűzrakó helyen — felelősen.' },
      ],
    },

    // ─── Host ───
    host: {
      label: 'Házigazdáitok',
      heading1: 'Péter',
      heading2: '& Zsuzsa',
      desc: '2022 májusában nyitottuk meg a haaziko-t első vendégeinknek. Azóta több mint 270 vendéget fogadtunk, és minden egyes alkalommal igyekszünk, hogy a haaziko egy igazi otthon legyen távol az otthontól. Egy üveg bor mindig vár az asztalon.',
      stats: [
        { main: '4 éve házigazda', sub: 'Tapasztalt Superhost' },
        { main: '100% válaszadás', sub: '1 órán belül válaszolnak' },
        { main: '4,97 ★ értékelés', sub: '270+ vélemény' },
        { main: 'Vendégfavorit', sub: 'Airbnb kiemelt szálláshely' },
      ],
      cta: 'Írj nekünk',
    },

    // ─── Booking ───
    booking: {
      label: 'Foglalás',
      heading: 'Válassz szabad',
      headingItalic: 'időpontot.',
      desc: 'Nézd meg a naptárban a szabad időpontokat, és foglald le közvetlenül nálunk — jutalékmentesen.',
      cta: 'Érdeklődöm',
      priceHint: 'A foglalások minimális hossza 2 éj, kivéve, ha foglalások között egy napos köztes időpont elérhetővé válik.',
      airbnbLink: 'Airbnb-n is foglalhatsz',
      selectDates: 'Válassz dátumokat',
      availabilityLabel: 'Elérhetőség',
      free: 'Szabad',
      booked: 'Foglalt',
      monthNames: ['Január', 'Február', 'Március', 'Április', 'Május', 'Június', 'Július', 'Augusztus', 'Szeptember', 'Október', 'November', 'December'],
      dayNames: ['H', 'K', 'Sze', 'Cs', 'P', 'Szo', 'V'],
    },

    // ─── Contact ───
    contact: {
      label: 'Kapcsolat',
      heading: 'Keress',
      headingItalic: 'minket.',
      desc: 'Kérdésed van? Írj emailben, WhatsApp-on, vagy keress meg minket közvetlenül. Általában 1 órán belül válaszolunk.',
      emailLabel: 'Email',
      phoneLabel: 'Telefon',
      whatsapp: 'WhatsApp',
      airbnb: 'Foglalás Airbnb-n',
      instagram: 'Kövess minket',
    },

    // ─── SEO Meta ───
    seo: {
      title: 'haaziko. | Alpesi A-frame Vendégház Esztergom, Pilis',
      description: 'A haaziko az erdő szélén, privát 4000 m²-es területen található alpesi faház — élvezd a jacuzzit, a nagy napozó teraszt és a kerti sütögetőt.',
      ogTitle: 'haaziko. | Alpesi A-frame Vendégház Esztergom',
      ogDescription: 'Alpesi A-frame faház az erdő szélén, privát 4000 m²-es területen. Jacuzzi, 80 m² napozóterasz, kerti sütögető — Budapesttől 1 órára.',
    },

    // ─── GYIK (a tartalom egyezik az index.html FAQPage sémájával) ───
    faq: {
      label: 'Gyakori kérdések',
      title: 'Amit a vendégeink leggyakrabban kérdeznek',
      items: [
        { q: 'Mikor lehet bejelentkezni és kijelentkezni?', a: 'Bejelentkezés 15:00 után, kijelentkezés 11:00 előtt. Az önálló bejutás biztosított, nincs szükség személyes fogadásra.' },
        { q: 'Van parkoló a háznál?', a: 'Igen, ingyenes parkoló áll rendelkezésre közvetlenül a szállásnál.' },
        { q: 'Hány főt fogad a haaziko?', a: 'A ház maximálisan 4 fő befogadására alkalmas. Az alap berendezés 2-3 főre készült.' },
        { q: 'Hol alszunk a haazikóban?', a: 'A galérián egy kétszemélyes ágy található — ez tölti be a hálószoba szerepét. Rajta kívül a nappali kanapéján még ketten elférnek, így összesen legfeljebb 4 fő.' },
        { q: 'Van jacuzzi a haazikóban?', a: 'Igen. A kültéri jacuzzi a ház melletti fa teraszon áll, az ősfák alatt, és egész évben üzemel — a hűvös estéken és télen is a vendégek kedvence. Használata a foglalás része, nem jár érte külön díj.' },
        { q: 'Hozhatok kisállatot?', a: 'Sajnos kisállat nem hozható a szállásra.' },
        { q: 'Milyen messze van Budapesttől?', a: 'A haaziko Esztergomban, a Pilis-hegység lábánál található — Budapesttől autóval körülbelül 1 óra.' },
        { q: 'Van WiFi?', a: 'Igen, stabil WiFi internet elérhető a házban.' },
        { q: 'Lehet tábortüzet rakni?', a: 'Igen, a kertben kijelölt tábortűzrakó hely áll rendelkezésre, ahol felelősen tüzet lehet gyújtani.' },
        { q: 'Hogyan tudok foglalni?', a: 'Közvetlenül itt a weboldalon a Foglalás szekcióban, az Airbnb-n, vagy telefonon és e-mailben: +36 30 637 7352, ahaaziko@gmail.com.' },
      ],
    },

    // ─── Cookie Consent ───
    cookie: {
      text: 'Az oldal sütiket (cookie-kat) használ a látogatási statisztikák és a jobb felhasználói élmény érdekében.',
      privacyLink: 'Adatkezelési tájékoztató',
      accept: 'Elfogadom',
      necessary: 'Csak szükséges',
    },

    // ─── Sticky CTA ───
    stickyCta: 'Foglalj',

    // ─── WhatsApp ───
    whatsappMessage: 'Szia! Érdeklődöm a haaziko foglalással kapcsolatban.',

    // ─── Footer ───
    footer: {
      tagline: 'Alpesi faház a Pilis lábánál, az erdő szélén. Budapesttől 1 órára.',
      navigation: 'Navigáció',
      contact: 'Kapcsolat',
      address: '2500 Esztergom, Kusztusi utca 17.',
      privacy: 'Adatkezelési tájékoztató',
      madeBy: 'Készítette az Ozone Digital',
      ntak: 'NTAK regisztrációs szám: MA22048583',
      aszf: 'ÁSZF',
      copyright: 'Minden jog fenntartva.',
      links: [
        { label: 'Programok', hash: '#activities' },
        { label: 'Galéria', hash: '#gallery' },
        { label: 'Helyszín', hash: '#location' },
        { label: 'Házirend', hash: '#hazirend' },
        { label: 'Foglalás', hash: '#booking' },
        { label: 'Kapcsolat', hash: '#contact' },
      ],
    },
  },

  en: {
    // ─── Navbar ───
    nav: {
      activities: 'Activities',
      gallery: 'Gallery',
      reviews: 'Reviews',
      location: 'Location',
      houseRules: 'House Rules',
      contact: 'Contact',
      booking: 'Book',
    },

    // ─── Hero ───
    hero: {
      tagline: 'Esztergom · At the foot of the Pilis Mountains',
      subtitle: 'Guest favorite Alpine chalet surrounded by nature.',
      cta: 'Explore',
    },

    // ─── About ───
    about: {
      label: 'The Place',
      heading1: 'peace',
      heading2: 'awaits.',
      p1: 'haaziko is an Alpine chalet at the edge of the forest in the Pilis hills, one hour from Budapest. The wooden deck has an outdoor jacuzzi, open all year round. We recommend it to nature lovers seeking relaxation in a bird-singing, green environment.',
      p2: 'On the nearly 4,000 m² tree-filled estate, the 80 m² terrace is perfect for morning coffee, squirrel-watching, and afternoon sunbathing. From the hilltop you can admire the panoramic view of the surrounding mountains — and in the evenings, enjoy a barbecue or bonfire in the garden.',
      cta: 'Take a look',
    },

    // ─── Gallery ───
    gallery: {
      label: 'The Accommodation',
      heading: 'Take a look',
      headingItalic: 'around.',
      cats: {
        interior: {
          label: 'Interior & Bedroom',
          desc: 'An open, modern space with floor-to-ceiling glass wall. The living room and bedroom form a unified, harmonious whole — every detail is tasteful and comfortable.',
        },
        kitchen: {
          label: 'Kitchen & Bathroom',
          desc: 'Fully equipped kitchen and elegant bathroom — everything you need for a comfortable stay.',
        },
        garden: {
          label: 'Garden & Terrace',
          desc: '80 m² panoramic terrace overlooking the Pilis hills. Nearly 4,000 m² of ancient tree-filled grounds with barbecue and bonfire facilities.',
        },
        mood: {
          label: 'Atmosphere',
          desc: 'A snowy fairy tale in winter, a green oasis in summer. The house shows a different face each season — but the tranquility and closeness to nature remain constant.',
        },
      },
    },

    // ─── Stats ───
    stats: [
      { value: '1', unit: 'h', label: 'from Budapest' },
      { value: '4000', unit: 'm²', label: 'tree-filled estate' },
      { value: '80', unit: 'm²', label: 'panoramic terrace' },
      { value: '4.97', unit: '★', label: 'Airbnb rating' },
    ],

    // ─── Activities ───
    activities: {
      label: 'Activities',
      heading: 'Experiences',
      headingItalic: 'that await.',
      items: [
        {
          title: 'Outdoor Jacuzzi',
          desc: 'On the wooden deck beside the house, under the old trees. Open all year round and included in your stay — a guest favourite on cool evenings, in autumn and in winter.',
        },
        {
          title: 'Garden BBQ & Bonfire',
          desc: 'The nearly 4,000 m² tree-filled garden has its own grill and bonfire pit. Evening campfire cooking, marshmallow roasting, starry sky — the authentic countryside experience.',
        },
        {
          title: 'Sun Terrace',
          desc: '80 m² corner terrace with panoramic views of the Pilis mountains. Morning coffee, squirrel-watching, afternoon sunbathing — or just sit back and listen to the silence.',
        },
        {
          title: 'Hiking in the Pilis',
          desc: 'Marked hiking trails in the Pilis start right near the house. Holop Spring, Dobogókő, Esztergom-Kőhegy — ideal terrain for both beginners and experienced hikers.',
        },
      ],
    },

    // ─── Amenities ───
    amenities: {
      label: 'Amenities',
      heading: 'Everything included.',
      items: [
        { name: 'Jacuzzi', desc: 'Outdoor jacuzzi on the wooden deck beside the house, open all year at no extra charge — the favourite on cool evenings and in winter.' },
        { name: 'Panoramic Estate', desc: 'Nearly 4,000 m² tree-filled plot on a hilltop with views of the surrounding mountains.' },
        { name: 'Bonfire & Grill', desc: 'Evening barbecue, campfire cooking and bonfires in the garden.' },
        { name: 'Breakfast on the Terrace', desc: '80 m² terrace — morning coffee, squirrel watching and afternoon sunbathing.' },
        { name: 'AC & Floor Heating', desc: 'Stay cool in summer with the split AC, warm in winter with underfloor heating.' },
        { name: 'HD-TV & Netflix', desc: '32-inch HD TV and Netflix for evening movie nights.' },
        { name: 'Stable WiFi', desc: 'Fast internet connection — work remotely, video calls run smoothly.' },
        { name: 'Free Parking', desc: 'Enclosed courtyard, right next to the house.' },
        { name: 'Self Check-in', desc: 'Code lockbox for flexible arrival at any time.' },
      ],
    },

    // ─── Testimonials ───
    testimonials: {
      label: 'Our guests said',
      airbnbSuffix: 'reviews · Airbnb',
      googleSuffix: 'reviews · Google',
      seeAll: 'All reviews',
      reviews: [
        { name: 'Ferenc', text: 'When stunning design and style don\'t come at the expense of comfort and practicality. Everything is truly as you\'d wish — you never feel it\'s too pretty to be a home. Because it is. A home.' },
        { name: 'Dóra', text: 'A wonderful little house in the gentle embrace of nature — we loved it. Exactly as in the pictures: impeccably beautiful, comfortable and well-equipped. The surroundings are stunning, with countless hiking opportunities.' },
        { name: 'Marcell', text: 'A very peaceful, nature-close, tranquil place — perfect for a retreat and rest. The accommodation looks amazing, designed with impeccable taste, and the evening bonfire option is simply the cherry on top.' },
        { name: 'Alina', text: 'From the very first moment it felt warm, clean and incredibly homely — a true home away from home. As if I were in a snowy winter fairy tale. It was hard to leave.' },
        { name: 'Mátyás', text: 'A truly beautiful, excellently maintained and well-equipped house. The place radiates a magical atmosphere. A perfect choice for couples — the surroundings are always quiet and peaceful.' },
        { name: 'Cintia', text: 'We celebrated my partner\'s birthday here for the second time at this wonderful place. We\'ll definitely be back — if it\'s up to us, every birthday will be celebrated here.' },
      ],
    },

    // ─── Location ───
    location: {
      label: 'Location',
      heading: 'At the forest\'s edge,',
      headingItalic: 'yet close to everything.',
      addressTitle: '2500 Esztergom, Kusztusi utca 17.',
      addressDesc: 'At the forest\'s edge, in a peaceful setting, on nearly 4,000 m² of ancient tree-filled land',
      distanceTitle: '1 hour from Budapest',
      distanceDesc: 'Easily reachable by car, with a secure parking lot right beside the house',
      nearbyHeading: 'What to do nearby',
      nearbyItems: [
        { name: 'Hiking in the Pilis', desc: 'Numerous marked hiking trails start near the house (Duna–Ipoly National Park)', href: 'https://www.dunaipoly.hu/' },
        { name: 'Esztergom City Centre', desc: 'Basilica, museums, restaurants — a few minutes by car', href: 'https://www.bazilika-esztergom.hu/' },
        { name: 'Fishing Lake', desc: 'Several fishing lakes can be found nearby' },
        { name: 'Holop Spring', desc: 'A natural attraction reachable with a short walk' },
      ],
      paragraph: 'A great advantage of haaziko is that while it offers a unique, peaceful and nature-close environment, the proximity of Esztergom allows for urban and cultural activities: you can be in the city centre in just a few minutes — museums, restaurants and cafés await at the main square or near the Basilica.',
    },

    // ─── House Rules ───
    houseRules: {
      label: 'House Rules',
      heading: 'A few',
      headingItalic: 'things to know.',
      checkinTitle: 'Check-in',
      checkinValue: 'from 15:00',
      checkoutTitle: 'Check-out',
      checkoutValue: 'by 11:00',
      maxGuestsLabel: 'max. guests',
      maxGuestsPara: 'The maximum number of guests at haaziko is 4. Please ensure all guests are aware of the house rules.',
      rules: [
        { title: 'Non-smoking', desc: 'Smoking is strictly prohibited throughout the property.' },
        { title: 'No pets', desc: 'Unfortunately, we are unable to accommodate pets.' },
        { title: 'Maximum occupancy', desc: '4 guests — please respect the stated number of guests.' },
        { title: 'Quiet hours', desc: 'Please keep quiet between 22:00 and 08:00 for the neighbours\' sake.' },
        { title: 'Tidiness', desc: 'Please return the house in the tidy condition it was in upon your arrival.' },
        { title: 'Fire safety', desc: 'Fires only in the designated firepit — responsibly.' },
      ],
    },

    // ─── Host ───
    host: {
      label: 'Your Hosts',
      heading1: 'Péter',
      heading2: '& Zsuzsa',
      desc: 'We opened haaziko to our first guests in May 2022. Since then we have welcomed over 270 guests, and every time we strive to make haaziko a true home away from home. A bottle of wine always awaits on the table.',
      stats: [
        { main: 'Hosting for 4 years', sub: 'Experienced Superhost' },
        { main: '100% response rate', sub: 'Responds within 1 hour' },
        { main: '4.97 ★ rating', sub: '270+ reviews' },
        { main: 'Guest Favourite', sub: 'Featured Airbnb property' },
      ],
      cta: 'Get in touch',
    },

    // ─── Booking ───
    booking: {
      label: 'Booking',
      heading: 'Choose your',
      headingItalic: 'dates.',
      desc: 'Check the calendar for available dates and book directly with us — commission-free.',
      cta: 'Enquire',
      priceHint: 'Minimum booking length is 2 nights, except when a single-night gap between bookings becomes available.',
      airbnbLink: 'Book on Airbnb',
      selectDates: 'Select dates',
      availabilityLabel: 'Availability',
      free: 'Available',
      booked: 'Booked',
      monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      dayNames: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
    },

    // ─── Contact ───
    contact: {
      label: 'Contact',
      heading: 'Get in',
      headingItalic: 'touch.',
      desc: 'Have a question? Write us an email, WhatsApp us, or reach out directly. We usually respond within 1 hour.',
      emailLabel: 'Email',
      phoneLabel: 'Phone',
      whatsapp: 'WhatsApp',
      airbnb: 'Book on Airbnb',
      instagram: 'Follow us',
    },

    // ─── SEO Meta ───
    seo: {
      title: 'haaziko. | Alpine A-frame Chalet Esztergom, Pilis',
      description: 'haaziko is an Alpine A-frame chalet at the forest edge on a private 4,000 m² plot — enjoy the jacuzzi, the large sun terrace and the garden fire pit.',
      ogTitle: 'haaziko. | Alpine A-frame Chalet Esztergom',
      ogDescription: 'Alpine A-frame chalet at the forest edge on a private 4,000 m² plot. Jacuzzi, 80 m² sun terrace, garden fire pit — 1 hour from Budapest.',
    },

    // ─── FAQ (matches the FAQPage schema in index.html) ───
    faq: {
      label: 'Frequently asked questions',
      title: 'What our guests ask most often',
      items: [
        { q: 'When can I check in and check out?', a: 'Check-in is after 15:00, check-out before 11:00. Self check-in is available, no in-person handover needed.' },
        { q: 'Is there parking at the house?', a: 'Yes, free parking is available right at the property.' },
        { q: 'How many guests can haaziko host?', a: 'The house accommodates up to 4 guests. The standard setup is designed for 2-3 people.' },
        { q: 'Where do we sleep at haaziko?', a: 'There is a double bed on the gallery level — this serves as the bedroom. Two more guests can sleep on the sofa in the living room, so up to 4 people in total.' },
        { q: 'Is there a jacuzzi at haaziko?', a: 'Yes. The outdoor jacuzzi sits on the wooden deck beside the house, under the old trees, and it runs all year round — a guest favourite on cool evenings and in winter. It is included in your stay at no extra charge.' },
        { q: 'Can I bring a pet?', a: 'Unfortunately pets are not allowed.' },
        { q: 'How far is it from Budapest?', a: 'haaziko is in Esztergom, at the foot of the Pilis hills — about 1 hour by car from Budapest.' },
        { q: 'Is there WiFi?', a: 'Yes, stable WiFi is available in the house.' },
        { q: 'Can we make a bonfire?', a: 'Yes, there is a designated fire pit in the garden where you can responsibly light a fire.' },
        { q: 'How do I book?', a: 'Directly here on the website in the Booking section, on Airbnb, or by phone or e-mail: +36 30 637 7352, ahaaziko@gmail.com.' },
      ],
    },

    // ─── Cookie Consent ───
    cookie: {
      text: 'This site uses cookies for visitor statistics and to improve the user experience.',
      privacyLink: 'Privacy Policy',
      accept: 'Accept',
      necessary: 'Necessary only',
    },

    // ─── Sticky CTA ───
    stickyCta: 'Book',

    // ─── WhatsApp ───
    whatsappMessage: 'Hello! I\'d like to enquire about booking haaziko.',

    // ─── Footer ───
    footer: {
      tagline: 'Alpine chalet at the foot of the Pilis, at the forest\'s edge. 1 hour from Budapest.',
      navigation: 'Navigation',
      contact: 'Contact',
      address: '2500 Esztergom, Kusztusi utca 17.',
      privacy: 'Privacy Policy',
      madeBy: 'Built by Ozone Digital',
      ntak: 'NTAK registration number: MA22048583',
      aszf: 'Terms',
      copyright: 'All rights reserved.',
      links: [
        { label: 'Activities', hash: '#activities' },
        { label: 'Gallery', hash: '#gallery' },
        { label: 'Location', hash: '#location' },
        { label: 'House Rules', hash: '#hazirend' },
        { label: 'Book', hash: '#booking' },
        { label: 'Contact', hash: '#contact' },
      ],
    },
  },
} as const;

export type Translations = typeof translations.hu;
